import React from 'react';

import { SectionTitle } from '@components/SideFeedItems/SectionTitle';

import { DirectorOfBoard } from '../../interfaces';
import DirectorItem from './DirectorItem';
import { OrgChartCompanyBoardOfDirectorsProps } from './interfaces';

const OrgChartBoardOfDirectors = (props: OrgChartCompanyBoardOfDirectorsProps) => {
  return (
    <section className="mb-64">
      <SectionTitle title="Board of Directors" />
      <div className="flex flex-wrap items-center gap-16">
        {props.directors?.length > 0 &&
          props.directors.map((director: DirectorOfBoard, index: number) => (
            <DirectorItem key={index} director={director} />
          ))}
      </div>
    </section>
  );
};

export default OrgChartBoardOfDirectors;
